import "./HeaderHero.scss";
import { Link } from "react-router-dom";

const HeaderHero = ({
  title = "CHOOSE YOUR PACKAGES",
  subtitle = "Select your desired media budgets and packages.",
  disclaimer = "",
}) => {
  return (
    <div className="form-hero-container">
      <div className="logo-container-wrapper">
        <div className="logo-container">
          <div className="header-hero-bar-left">
            <Link to="/" className="header-hero-back">
              ← BACK
            </Link>
          </div>
          <div className="header-hero-bar-center">
            <div className="logo-text">
              <p>JLR</p>
              <p>RETAILER DIGITAL PROGRAM</p>
            </div>
          </div>
          <div className="header-hero-bar-right">
              <p className="header-hero-trailing">POWERED BY CONSTELLATION</p>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default HeaderHero;
